import React from "react";

const ContributionType = (props) => {
  let ctype = "";
  if (props.ctype) {
    if (props.ctype.length > 2) {
      let words = props.ctype.split("_");
      for (let w of words) {
        ctype += w.charAt(0);
      }
    } else {
      ctype = props.ctype;
    }
  }
  if (ctype && ctype !== "n") {
    return <span className={`tbl-type tbl-${ctype}`}>{ctype}</span>;
  }
  return <span></span>;
};

export default ContributionType;
